<template>
  <CustomModal ref="modal" class="manage-business-modal" title="Gérrer un devis">
    <div>
      <CustomForm ref="form" :submit=buttons.submit>
        <CustomButton class="submit-button" @click="$refs.addCreditNoteModal.openModal(business)" :params=buttons.openCreditNoteCreation style="margin-top: 15px"/>
        <CustomButton class="submit-button" @click="$refs.addAmendmentModal.openModal(business)" :params=buttons.openAmendmentCreation style="margin-top: 15px"/>
        <CustomButton class="submit-button" @click="$refs.duplicateBusinessModal.openModal(business)" :params=buttons.openDuplicateQuote style="margin-top: 15px"/>
      </CustomForm>
    </div>
  </CustomModal>
  <AddAmendmentModal ref="addAmendmentModal" :callback=terminate />
  <AddCreditNoteModal ref="addCreditNoteModal" :callback=terminate />
  <DuplicateBusinessModal ref="duplicateBusinessModal" :callback=terminate />
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import AddAmendmentModal from "@/components/modals/AddAmendmentModal.vue";
import DuplicateBusinessModal from "@/components/modals/DuplicateBusinessModal.vue";
import AddCreditNoteModal from "@/components/modals/AddCreditNoteModal.vue";

  export default {
      name: 'ManageBusinessModal',
      props: ['callback'],
      components: {AddCreditNoteModal, DuplicateBusinessModal, AddAmendmentModal, CustomModal, CustomForm, CustomButton},
      data() {
          return {
            business: undefined,
            buttons:{
              openCreditNoteCreation: {text: "Créer un avoir"},
              openAmendmentCreation: {text: "Créer un avenant", disabled: true},
              openDuplicateQuote: {text: "Dupliquer"}
            }
          };
      },
      methods: {
        async openModal(business) {
          this.business = business;
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback();
        },
        async submitForm() {

        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';
</style>

<style lang="stylus">
  .manage-business-modal .modal
    width 400px !important
</style>